var _defs, _rect, _g, _path, _circle, _path2, _circle2, _circle3, _path3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationGateway(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "application-gateway_svg__b",
    x1: 9,
    y1: 19.25,
    x2: 9,
    y2: -0.46,
    gradientTransform: "rotate(45 9.003 8.999)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e9624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6dad2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76bc2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "application-gateway_svg__a",
    x1: 7.54,
    y1: 6.44,
    x2: 7.53,
    y2: 5.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcfcfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "application-gateway_svg__c",
    x1: 9.36,
    y1: 7.69,
    x2: 9.36,
    y2: 6.57,
    href: "#application-gateway_svg__a"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.82,
    y: 2.82,
    width: 12.35,
    height: 12.35,
    rx: 0.57,
    transform: "rotate(-45 8.999 9.003)",
    fill: "url(#application-gateway_svg__b)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.89 10.51h2.84a.11.11 0 00.1-.11V7.57a.1.1 0 00-.18-.07l-.78.78v.05a.1.1 0 01-.14 0L9.26 4.91a.1.1 0 00-.14 0l-.88.88a.11.11 0 000 .15l3.41 3.41a.11.11 0 010 .15l-.05.05-.78.78a.11.11 0 00.07.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92 10.51H4.08A.11.11 0 014 10.4V7.57a.1.1 0 01.17-.07l.79.78v.05a.1.1 0 00.14 0l3.45-3.42a.1.1 0 01.14 0l.88.88a.11.11 0 010 .15L6.16 9.35a.11.11 0 000 .15v.05l.78.78a.11.11 0 01-.02.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82 13.07l2 2a.1.1 0 00.14 0l2-2a.1.1 0 00-.07-.17H9.72a.11.11 0 01-.1-.1V8a.1.1 0 00-.1-.11H8.28a.11.11 0 00-.11.11v4.8a.1.1 0 01-.1.1H6.89a.1.1 0 00-.07.17z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.65 7.78A2.71 2.71 0 017.33 3.5a2.71 2.71 0 013.29 4.3",
    fill: "#0078d4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.53,
    cy: 5.55,
    r: 0.87,
    fill: "url(#application-gateway_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67 7l.19.3.14.2a5.94 5.94 0 01.34-1.1.85.85 0 01-.45-.23 6.71 6.71 0 00-.22.83zm.57-2.27A4 4 0 017 3.8a2.48 2.48 0 00-.34.46 3.51 3.51 0 00.2.74 1 1 0 01.38-.27zm.93 1.41a.87.87 0 01-.48.26 4.62 4.62 0 00.46.41 4.14 4.14 0 00.65.39v-.07a.53.53 0 01.2-.4 3.6 3.6 0 01-.83-.59zm2.62 1.06a4.14 4.14 0 01-.87-.1.55.55 0 01-.16.39 3.84 3.84 0 001.08.08 2.93 2.93 0 00.37-.42z",
    opacity: 0.55,
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.36,
    cy: 7.13,
    r: 0.56,
    fill: "url(#application-gateway_svg__c)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.64,
    cy: 5.74,
    r: 0.6,
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21 4.42A4.29 4.29 0 0111.09 4a2.24 2.24 0 00-.47-.45 4.5 4.5 0 00-1.49.35c-.1 0-.19.11-.29.16a5.85 5.85 0 01-.63-.93l-.34.13a5.35 5.35 0 00.65 1 3.92 3.92 0 00-.67.55.87.87 0 01.43.35 3.29 3.29 0 01.61-.48 9.16 9.16 0 001.17 1 .57.57 0 01.2-.32 8.44 8.44 0 01-1.05-.94zm2.34 1.67h-.18l-.1-.06a.61.61 0 01-.2.3l.12.07.11.06.28.14a3.58 3.58 0 00.09-.35z",
    opacity: 0.55,
    fill: "#f2f2f2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.53,
    cy: 5.55,
    r: 0.87,
    fill: "#f2f2f2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.36,
    cy: 7.13,
    r: 0.56,
    fill: "#f2f2f2"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgApplicationGateway as ReactComponent };